<template>
    <div>
        <div
            class="overlay"
            @click="close"
        ></div>

        <div
            class="menu"
            :class="{ open: isOpen }"
        >
            <div class="d-flex flex-column details-menu-div">
                <div class="d-flex justify-content-between details-menu-header">
                    <div></div>
                    <div class="d-flex align-items-center" style="padding: 0 8px; background: rgba(24, 24, 24, 1);">
                        <span class="material-symbols-outlined material-symbols-outlined-400 pointer close-icon"
                              @click="close">close</span>
                    </div>
                </div>
                <div class="d-flex w-100 flex-column form-menu">

                    <div class="d-flex w-100 justify-content-between menu-panel">
                        <ul class="navbar-nav menugap">
                            <li class="nav-item dropdown">
                                <a
                                    class="nav-link menu-item dropdown-toggle w-100"
                                    href="#"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                >
                                    Guide
                                </a>

                                <ul class="dropdown-menu">
                                    <li class="nav-link dropdown-link">
                                        <router-link
                                            class="menu-item-2nd"
                                            :to="{ name: 'mergerControl' }"
                                            @click="collapseNavbar"
                                        >
                                            Merger Control
                                        </router-link>
                                    </li>
                                    <li class="nav-link dropdown-link">
                                        <router-link
                                            class="menu-item-2nd"
                                            :to="{ name: 'foreignInvestments' }"
                                            @click="collapseNavbar"
                                        >
                                            Foreign Investment
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'decisions'}"
                                             @click="collapseNavbar"
                                             class="nav-link menu-item">
                                    Decisions
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'articles'}"
                                             @click="collapseNavbar"
                                             class="nav-link menu-item">
                                    Articles
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'newsView'}"
                                             @click="collapseNavbar"
                                             class="nav-link menu-item">
                                    News
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'jobsView'}"
                                             @click="collapseNavbar"
                                             class="nav-link menu-item">
                                    News
                                </router-link>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link menu-item dropdown-toggle w-100"
                                   href="#"
                                   role="button"
                                   data-bs-toggle="dropdown">
                                    Experts
                                </a>
                                <ul class="dropdown-menu">
                                    <li class="nav-link dropdown-link">
                                        <router-link class="menu-item-2nd"
                                                     :to="{ name: 'expertsLayers' }"
                                                     @click="collapseNavbar">
                                            Merger Control
                                        </router-link>
                                    </li>
                                    <li class="nav-link dropdown-link">
                                        <router-link class="menu-item-2nd"
                                                     :to="{ name: 'expertsForeignLawyers' }"
                                                     @click="collapseNavbar">
                                            Foreign Investment
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'authoritiesCompetition'}"
                                             @click="collapseNavbar"
                                             class="nav-link menu-item">
                                    Authorities
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'events'}"
                                             @click="collapseNavbar"
                                             class="nav-link menu-item">
                                    Events
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'about'}"
                                             @click="collapseNavbar"
                                             class="nav-link menu-item">
                                    About
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'maia'}"
                                             @click="collapseNavbar"
                                             class="nav-link menu-item">
                                    MaiA
                                </router-link>
                            </li>
                        </ul>

                        <ul v-if="!state.isUserLogged" class="navbar-nav buttongap">
                            <!--button class="btn btn-warning"
                                    @click="state.showSubscribeModal = true"
                                    type="button">
                                Subscribe
                            </button-->
                            <li class="nav-item">
                                <button type="button" class="btnBlackStyle gen-button" @click="showLogin">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <div class="btnBlackText">Contributor Log in</div>
                                    </div>
                                </button>
                            </li>

                            <li class="nav-item">
                                <router-link :to="{name: 'home', hash: '#newsletterForm'}"
                                             @click="collapseNavbar">
                                    <button type="button" class="btnBlueStyle gen-button">
                                        <div class="d-flex btnBlueStyleInner">
                                            <div class="btnBlueText">Free Updates</div>
                                            <span
                                                class="material-symbols-outlined material-symbols-outlined-400 arrow-icon"
                                            >arrow_forward</span>
                                        </div>
                                    </button>
                                </router-link>
                            </li>
                        </ul>

                        <ul v-if="state.isUserLogged" class="navbar-nav menugap">
                            <!--                            <li class="nav-item">
                                                            <router-link :to="{name: 'dashboard'}"
                                                                        @click="collapseNavbar"
                                                                        :class="{'active': route.meta.module === 'admin'}"
                                                                        class="nav-link menu-item">
                                                                Administration
                                                            </router-link>
                                                        </li>-->
                            <li class="nav-item">
                                <router-link :to="{name: 'userArea'}"
                                             @click="collapseNavbar"
                                             class="nav-link menu-item">
                                    <div class="d-flex gap-2 align-items-center">
                                        <font-awesome-icon icon="fa-solid fa-user"/>
                                        {{ state.userTitle }}
                                    </div>
                                </router-link>
                            </li>

                            <li class="nav-item">
                                <a href="javascript:void(0)"
                                   @click="logoutHandler"
                                   class="nav-link menu-item">
                                    <div class="d-flex gap-2 align-items-center">
                                        <font-awesome-icon icon="fa-solid fa-power-off"/>
                                        Logout
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script setup lang="ts">

import {computed, onMounted, onUnmounted, reactive, ref} from "vue";
import axios from "axios";
import {useMainStore} from "@/stores/mainStore";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

const mainStore = useMainStore();

defineProps(['isOpen'])
const emit = defineEmits(['close'])

const menuRef = ref<HTMLElement | null>(null)

const state = reactive({
    isUserLogged: computed<boolean>(() => !!mainStore.getLoggedUser),
    userTitle: computed<string>(() => !!mainStore.getLoggedUser ? mainStore.getLoggedUser.name : 'User'),
})

onMounted(() => {
    document.addEventListener("click", handleClickOutside);
})

onUnmounted(() => {
    document.removeEventListener("click", handleClickOutside);
})

function close() {
    emit('close')
}

const collapseNavbar = () => {
    setTimeout(() => {
        close()
    }, 150); // Delay to allow route animation if needed
};

const logoutHandler = async () => {
    collapseNavbar()
    await axios.post('/logout')
    window.location.assign('/')
}

function handleClickOutside(event: any) {
    const menuEl = menuRef.value;
    const isClickInsideSelectDropdown = (event.target as HTMLElement).closest('[role="listbox"]');
    if (
        menuEl &&
        !menuEl.contains(event.target as Node) &&
        !isClickInsideSelectDropdown
    ) {
        emit('close')
    }
}

const showLogin = () => {
    collapseNavbar()
    mainStore.showLogin(true)
}


</script>

<style scoped lang="scss">
.menu {
    position: fixed;
    top: 0;
    right: -70vw; /* start off screen */
    width: 70vw;
    height: 100vh;
    background: transparent;
    transition: right 0.3s ease;
    z-index: 2;
    @media (max-width: $max-sm-screen) {
        width: 100vw;
    }
}

.menu.open {
    right: 0;
}

.details-menu-header {
    width: 100%;
    height: 66px;
    padding: 0px 25px;

    align-items: center;
    line-height: 100%;
    color: rgba(255, 255, 255, 1);
}

.form-menu {
    background: rgba(24, 24, 24, 1);
    padding: 30px;
    margin-top: -1px;
    gap: 20px;
    height: calc(100vh - 66px);
    overflow-y: auto;
    @media (max-width: $max-sm-screen) {
        padding-top: 12px;
        padding-right: 25px;
        padding-left: 25px;
    }
}

.buttons-div {
    padding: 24px 50px 36px;
    gap: 20px;

    @media (max-width: $max-sm-screen) {
        padding: 24px 25px 36px;
    }
}

.btnClearStyle {
    padding: 20px 10px;
    gap: 2px;
    opacity: 1;
    border-radius: 2px;
    background: rgba(24, 24, 24, 1);
    border: 2px solid rgba(248, 250, 255, 1);
    box-shadow: 4px 4px 2px 0 rgba(0, 0, 0, 0.5), -2px -2px 2px 0 rgba(91, 92, 99, 0.3);

    @media (max-width: $max-sm-screen) {
        padding: 10px !important;
    }
}

.btnApplyStyle {
    padding: 20px 10px;
    gap: 2px;
    border-radius: 2px;

    background: linear-gradient(254.56deg, #3E69A6 0.74%, #233F68 99.26%);
    box-shadow: 4px 4px 2px 0 rgba(0, 0, 0, 0.5), -2px -2px 2px 0 rgba(91, 92, 99, 0.3);

    @media (max-width: $max-sm-screen) {
        padding: 10px;
    }
}

.btnDetailsText {
    font-family: Raleway;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    text-align: center;
    color: rgba(248, 250, 255, 1);

    @media (max-width: $max-md-screen) {
        font-size: 14px;
    }
}

.overlay {
    position: fixed;
    top: 65px;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6); /* 60% dark overlay */
    z-index: 1; /* must be below the menu but above page content */
}

.close-icon {
    font-size: 24px;
}

.nav-link.show,
.menu-item {
    font-family: Raleway;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: left;
    color: rgba(248, 250, 255, 1);
    text-decoration: none;
    display: flex;
    align-items: center !important;
    justify-content: space-between !important;

    @media (max-width: $max-md-screen) {
        font-size: 16px !important;
        padding: 0 16px;
        height: 65px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 14px !important;
        padding: 0 16px;
        height: 65px;
    }
}

.menu-item-2nd {
    font-family: Raleway;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: left;
    color: rgba(248, 250, 255, 1);
    text-decoration: none;
    display: flex;
    align-items: center !important;
    justify-content: space-between !important;
    padding: 0 4px;

    @media (max-width: $max-md-screen) {
        font-size: 14px !important;
        padding: 0 0 0 24px;
        height: 65px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 14px !important;
        padding: 0 0 0 24px;
        height: 65px;
    }
}

.menugap {
    display: flex;
    gap: 20px;
    @media (max-width: $max-md-screen) {
        gap: 60px;
        padding-bottom: 16px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 16px;
        padding-bottom: 16px;
    }
}

.buttongap {
    gap: 20px;

    @media (max-width: $max-md-screen) {
        gap: 20px;
        margin-top: 24px;
    }
}

.navbar-nav {
    align-items: center;
    @media (max-width: $max-md-screen) {
        width: 100%;
    }
}

.navbar-props {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 0;
    gap: 40px;
    background: rgba(24, 24, 24, 1) !important;
    box-shadow: 0 3px 2px 0 rgba(0, 0, 0, 0.25);

    @media (max-width: $max-md-screen) {
        gap: 10px;
        padding: 0 20px;
        position: fixed;
        width: 100vw;
    }
    @media (max-width: $max-sm-screen) {
        gap: 40px;
        padding: 0 20px;
        position: fixed;
        width: 100vw;
    }
}

.navbar-toggler {
    color: rgba(255, 255, 255, 1);
    border: 0 !important;
    outline: 0 !important;
    box-shadow: 0 0 0 0 !important;
}

.dropdown-menu {
    background: rgba(24, 24, 24, 1);
    gap: 25px;
    padding: 0;
    margin: 0;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-top: 4px solid rgba(62, 105, 166, 1);
    width: 100%;
    position: relative !important;
    transform: unset !important;
}

.dropdown-link {
    white-space: nowrap;
    margin-bottom: 25px;
    margin: 0;
    padding: 0;
}

.dropdown-link:last-child {
    margin-bottom: 0
}

.btnBlackStyle {
    height: 34px;
    padding: 5px 10px;
    gap: 8px;
    background: rgba(24, 24, 24, 1);
    border-radius: 2px;
    border: 1px solid rgba(248, 250, 255, 1);
    box-shadow: 4px 4px 2px 0 rgba(0, 0, 0, 0.5), -2px -2px 2px 0 rgba(91, 92, 99, 0.3);

    @media (max-width: $max-md-screen) {
        width: 100% !important;
        height: 44px;
        padding: 10px;
    }

    @media (max-width: $max-sm-screen) {
        width: 100% !important;
        height: 34px;
        padding: 5px 10px;
    }
}

.btnBlackText {
    color: rgba(248, 250, 255, 1);
    font-family: Raleway;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
    white-space: nowrap;
    @media (max-width: $max-md-screen) {
        font-size: 16px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 14px;
    }

}

.btnBlueStyle {
    height: 34px;
    gap: 2px;
    border-radius: 2px;
    padding: 5px 10px;
    background: linear-gradient(254.56deg, #3E69A6 0.74%, #233F68 99.26%);
    box-shadow: 4px 4px 2px 0 rgba(0, 0, 0, 0.5), -2px -2px 2px 0 rgba(91, 92, 99, 0.3);

    @media (max-width: $max-md-screen) {
        width: 100% !important;
        height: 44px;
        padding: 10px;
    }
    @media (max-width: $max-sm-screen) {
        width: 100% !important;
        height: 34px;
        padding: 5px 10px;
    }
}

.btnBlueStyleInner {
    justify-content: center;
    align-items: center;
    gap: 2px;
}

.btnBlueText {
    color: rgba(248, 250, 255, 1);
    font-family: Raleway;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
    white-space: nowrap;
    @media (max-width: $max-md-screen) {
        font-size: 16px;
    }
}

.navbar-toggler-icon {
    height: 1.5rem;
    width: 1.5rem;
    color: rgba(248, 250, 255, 1);
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(248, 250, 255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
}

::v-deep(.nav-item) {
    width: 100%;
    padding: 0;
}

::v-deep(.nav-link) {
    line-height: 100%;
}

.navbar-collapse {
    max-height: calc(100vh - 90px);
    overflow-y: auto;
}

.arrow-icon {
    color: #ffffff;
    font-size: 20px;
    @media (max-width: $max-md-screen) {
        font-size: 24px;
    }
}

@media (max-width: $max-md-screen) {
    .navbar-expand-md .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
    }
    .navbar-expand-md .navbar-toggler {
        display: none;
    }
    .navbar-expand-md .navbar-nav {
        flex-direction: column;
    }
    .menu-panel {
        flex-direction: column;
        gap: 60px;
    }
}

@media (max-width: $max-sm-screen) {
    .navbar-expand-md .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
    }
    .navbar-expand-md .navbar-toggler {
        display: none;
    }

    .navbar-expand-md .navbar-nav {
        flex-direction: column;
        padding-bottom: 30px;
    }
    .menu-panel {
        flex-direction: column;
        padding-top: 10px;
        padding-bottom: 30px;
        gap: 16px;
    }
}
</style>
